import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux'
import renderTextInputWithFeedback from '../../../../components/ui/forms/renderTextInputWithFeedback'
import formValidators from '../../../../utils/validation/formValidators'
import history from '../../../../utils/routing/history'
import selectors from '../../../../store/shared/selectors'
import notificationsUtils from '../../../../utils/notifications/notificationsUtils'
import * as forgotPasswordDuck from '../forgotPasswordDuck'

class ForgotPasswordForm extends Component {
  constructor(props) {
    super(props)

    this.clearAndGoBackToLogin = () => {
      this.props.clearForgotPassword()
      history.push('/login')
    }
  }
  render() {
    const { handleSubmit, pristine, invalid, isForgotPasswordRequestSuccessful } = this.props

    return isForgotPasswordRequestSuccessful ?
      (
        <div className="row">
          <div className="col text-center">
            <h6>Check your email for reset instructions!</h6>
            <br />
            <button className="btn btn-block btn-success" onClick={this.clearAndGoBackToLogin}>Back to Login</button>
          </div>
        </div>
      ) : (
        <div className="row">
          <div className="col">
            <form>
              <Field
                component={renderTextInputWithFeedback}
                name="email"
                placeholder="Email"
              />
              <button
                onClick={handleSubmit}
                className="btn btn-block btn-success"
                disabled={pristine || invalid}
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      )
  }
}

ForgotPasswordForm.propTypes = {
  invalid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  performForgotPassword: PropTypes.func.isRequired,
  clearForgotPassword: PropTypes.func.isRequired,
  isForgotPasswordRequestSuccessful: PropTypes.bool.isRequired,
}

ForgotPasswordForm.defaultProps = {}


/**
 * @const validate
 * @desc Checks whether our form is valid
 * @param values
 * @returns {{}}
 */
const validate = values => {
  const errors = {}
  errors.email = formValidators.isRequired(values.email)
  errors.email = formValidators.isAnEmail(values.email)
  return errors
}


/**
 * @const wrappedWithForm
 * @desc Gives ForgotPasswordForm extra props like invalid, pristine, and handleSubmit
 */
const wrappedWithForm = reduxForm({
  form: 'forgotPasswordForm',
  onSubmit: async (values, _dispatch, props) => {
    try {
      await props.performForgotPassword(values)
      notificationsUtils.showSuccessNotification('Check your email for instructions!')
      // @TODO Navigate them to the next step
    } catch (error) {
      notificationsUtils.showErrorNotification(error.message)
    }
  },
  validate,
})(ForgotPasswordForm)


/**
 * @const makeMapStateToProps
 * @param state
 */
const makeMapStateToProps = () => {
  const isRequestSuccessful = selectors.makeGetIsRequestSuccessful()
  return state => ({
    isForgotPasswordRequestSuccessful: isRequestSuccessful(state, 'forgotPassword'),
  })
}


/**
 * @const mapDispatchToProps
 * @desc Binds an Action Performer to this.props
 * @param dispatch
 */
const mapDispatchToProps = dispatch =>
  bindActionCreators({
    clearForgotPassword: forgotPasswordDuck.clearForgotPassword,
    performForgotPassword: forgotPasswordDuck.performForgotPassword,
  }, dispatch)


export default connect(makeMapStateToProps, mapDispatchToProps)(wrappedWithForm)



// WEBPACK FOOTER //
// ./src/routes/unauthenticated/ForgotPassword/components/ForgotPasswordForm.js